<template>
    <div>
        <h2>Лабораторные исследования</h2>
        <lab-surveys
            :patient-id="patientId"
            :back-navigation-context="backNavigationContext"
            :restore-state="restoreState"
            :source-page-name="sourcePageName"
            survey-base-url="/survey/"
            @restored="$emit('restored')"
        />
    </div>
</template>

<script>
import LabSurveys from '@/components/surveys/LabSurveys.vue';

export default {
    components: {
        LabSurveys,
    },
    props: {
        patientId: {
            type: Number,
            required: true,
        },
        backNavigationContext: {
            type: Object,
            default: null,
        },
        restoreState: {
            type: Object,
            default: null,
        },
        sourcePageName: {
            type: String,
            default: null,
        },
    },
    emits: ['restored'],
};
</script>

<style lang="scss">
.survey-table {
    margin-bottom: 20px;

    .hidden-expander {
        .ant-table-row-expand-icon {
            display: none;
        }
    }
}
</style>
